import { ITypedReduxAction } from '../../types/redux/actionType';
import { ISessionToken } from '../../types/session';

export enum ESessionActionTypes {
  SetPending = 'chats/session/setPending',
  SetSucceed = 'chats/session/setSucceed',
  SetFailed = 'chats/session/setFailed',
}

export type TSessionActions =
  | ITypedReduxAction<ESessionActionTypes.SetSucceed, ISessionToken>
  | ITypedReduxAction<ESessionActionTypes.SetFailed, void>
  | ITypedReduxAction<ESessionActionTypes.SetPending, void>;
